import type { Name } from '../../chats'

import { useQuery } from '@tanstack/react-query'

import http from '../../../lib/http'

interface Patient {
  name: Name[]
}

interface UsePatientQueryKey {
  patientId?: string | null
}

interface PatientQueryOptions {
  patientId?: string | null
}

type PatientQueryKey = [
  'patient',
  string | undefined | null
]

export function patientQueryKey (options: UsePatientQueryKey): PatientQueryKey {
  return [
    'patient',
    options.patientId
  ]
}


export function usePatientQuery (options: PatientQueryOptions) {
  return useQuery({
    queryKey: patientQueryKey({ patientId: options.patientId }),
    async queryFn ({ queryKey }) {
      const [ ,patientId ] = queryKey

      if (!patientId) {
        return null
      }

      const result = await http.getRequest(`/patients/${patientId.replace('Patient/', '')}`)

      return result as Patient
    },
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!options.patientId
  })
}
